import Vue from "vue";
import VueRouter from "vue-router";
import roleEnum from "@/utils/enums/roleEnum";
import utils from "@/utils/utils";
import device from "@/utils/device";
import store from "@/store";

const { isNavigationFailure, NavigationFailureType } = VueRouter;
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  originalPush.call(this, location).catch((failure) => {
    if (!isNavigationFailure(failure, NavigationFailureType.duplicated)) {
      throw new Error(failure);
    }
  });
};

Vue.use(VueRouter);

const defaultRoutes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
    meta: {
      title: "",
      hidden: true,
      hideHeader: true,
      hideFooter: true,
    },
  },
  {
    path: "/collegeRecruit",
    name: "CollegeRecruit",
    component: () => import("@/views/CollegeRecruit/Index.vue"),
    meta: {
      title: "校园招聘",
      isCandidatePage: true, // 是否为应聘人员页面
    },
  },
  {
    path: "/collegeRecruit/:companyId",
    name: "Company",
    component: () => import("@/views/CollegeRecruit/Company.vue"),
    meta: {
      title: "校园招聘",
      hidden: true,
      showHomepageLink: true, // 是否显示首页链接
      isCandidatePage: true, // 是否为应聘人员页面
      activePath: "/collegeRecruit",
    },
  },
  {
    path: "/socialRecruit",
    name: "SocialRecruit",
    component: () => import("@/views/CollegeRecruit/Index.vue"),
    meta: {
      title: "社会招聘",
      isCandidatePage: true, // 是否为应聘人员页面
    },
  },
  {
    path: "/socialRecruit/:companyId",
    name: "SocialCompany",
    component: () => import("@/views/CollegeRecruit/Company.vue"),
    meta: {
      title: "社会招聘",
      hidden: true,
      showHomepageLink: true, // 是否显示首页链接
      isCandidatePage: true, // 是否为应聘人员页面
      activePath: "/socialRecruit",
    },
  },
];

const routes = [
  // {
  //   path: "/",
  //   name: "Home",
  //   component: () => import('@/views/Home/Index.vue'),
  //   meta: {
  //     title: '首页',
  //     roles: [roleEnum.RECRUIT.name]
  //   }
  // },
  {
    path: "/enterprise",
    name: "Enterprise",
    component: () => import("@/views/EnterpriseInfo/Index.vue"),
    meta: {
      title: "企业信息",
      roles: [roleEnum.RECRUIT.name, roleEnum.RECRUIT_MANAGER.name],
    },
  },
  {
    path: "/position",
    name: "Position",
    component: () => import("@/views/Position/PositionList.vue"),
    meta: {
      title: "职位",
      roles: [
        roleEnum.RECRUIT.name,
        roleEnum.RECRUIT_MANAGER.name,
        roleEnum.ADMIN.name,
      ],
    },
  },
  {
    path: "/position/:id",
    name: "PositionDetail",
    component: () => import("@/views/Position/Detail.vue"),
    meta: {
      title: "职位",
      hidden: true,
      roles: [
        roleEnum.RECRUIT.name,
        roleEnum.RECRUIT_MANAGER.name,
        roleEnum.ADMIN.name,
      ],
      activePath: "/position",
    },
  },
  {
    path: "/receiveResume",
    name: "ReceiveResume",
    component: () => import("@/views/Position/ReceiveResume.vue"),
    meta: {
      title: "职位",
      hidden: true,
      roles: [roleEnum.RECRUIT.name, roleEnum.ADMIN.name],
      activePath: "/position",
    },
  },
  // {
  //   path: "/findPeople",
  //   name: "FindPeople",
  //   component: () => import("@/views/FindPeople/Index.vue"),
  //   meta: {
  //     title: "找人",
  //     roles: [roleEnum.RECRUIT.name],
  //   },
  // },
  {
    path: "/enterprisePosition",
    name: "EnterprisePosition",
    component: () => import("@/views/Platform/EnterprisePosition.vue"),
    meta: {
      title: "企业职位",
      roles: [roleEnum.ADMIN.name],
    },
  },
  {
    path: "/resumeDB",
    name: "ResumeDB",
    component: () => import("@/views/ResumeDB/Index.vue"),
    meta: {
      title: "简历库",
      roles: [roleEnum.ADMIN.name],
    },
  },
  {
    path: "/platform",
    name: "Platform",
    component: () => import("@/views/Platform/Index.vue"),
    meta: {
      title: "平台管理",
      roles: [roleEnum.ADMIN.name],
    },
    children: [
      {
        path: "cover",
        name: "Cover",
        component: () => import("@/views/Cover/Index.vue"),
        meta: {
          title: "平台封面维护",
        },
      },
      {
        path: "enterprise",
        name: "PlatformEnterprise",
        component: () => import("@/views/Platform/Enterprise.vue"),
        meta: {
          title: "企业信息管理",
        },
      },
      {
        path: "enterprise/:id",
        name: "EnterpriseDetail",
        component: () => import("@/views/Platform/EnterpriseDetail.vue"),
        meta: {
          title: "企业信息管理",
          hidden: true,
        },
      },
      {
        path: "role",
        name: "UserRole",
        component: () => import("@/views/Platform/UserRole.vue"),
        meta: {
          title: "用户角色管理",
        },
      },
      {
        path: "sensitiveword",
        name: "SensitiveWord",
        component: () => import("@/views/SensitiveWord/Index.vue"),
        meta: {
          title: "敏感词汇管理",
        },
      },
      {
        path: "AnnualDataManagement",
        name: "AnnualDataManagement",
        component: () => import("@/views/Platform/AnnualDataManagement.vue"),
        meta: {
          title: "历年数据管理",
        },
      },
    ],
  },
  {
    path: "/collegeRecruit",
    name: "CollegeRecruit",
    component: () => import("@/views/CollegeRecruit/Index.vue"),
    meta: {
      title: "校园招聘",
      roles: [roleEnum.CANDIDATE.name],
      isCandidatePage: true, // 是否为应聘人员页面
    },
  },
  {
    path: "/collegeRecruit/:companyId",
    name: "Company",
    component: () => import("@/views/CollegeRecruit/Company.vue"),
    meta: {
      title: "校园招聘",
      roles: [roleEnum.CANDIDATE.name],
      hidden: true,
      showHomepageLink: true, // 是否显示首页链接
      isCandidatePage: true, // 是否为应聘人员页面
      activePath: "/collegeRecruit",
    },
  },
  {
    path: "/socialRecruit",
    name: "SocialRecruit",
    component: () => import("@/views/CollegeRecruit/Index.vue"),
    meta: {
      title: "社会招聘",
      roles: [roleEnum.CANDIDATE.name],
      isCandidatePage: true, // 是否为应聘人员页面
    },
  },
  {
    path: "/socialRecruit/:companyId",
    name: "SocialCompany",
    component: () => import("@/views/CollegeRecruit/Company.vue"),
    meta: {
      title: "社会招聘",
      roles: [roleEnum.CANDIDATE.name],
      hidden: true,
      showHomepageLink: true, // 是否显示首页链接
      isCandidatePage: true, // 是否为应聘人员页面
      activePath: "/socialRecruit",
    },
  },
  {
    path: "/myResume",
    name: "MyResume",
    component: () => import("@/views/MyResume/Index.vue"),
    meta: {
      hidden: true,
      roles: [roleEnum.CANDIDATE.name],
      showHomepageLink: true, // 是否显示首页链接
      isCandidatePage: true, // 是否为应聘人员页面
    },
  },
  {
    path: "/deliverRecord",
    name: "DeliverRecord",
    component: () => import("@/views/DeliverRecord/Index.vue"),
    meta: {
      hidden: true,
      roles: [roleEnum.CANDIDATE.name],
      showHomepageLink: true, // 是否显示首页链接
      isCandidatePage: true, // 是否为应聘人员页面
    },
  },
];

const createRouter = () =>
  new VueRouter({
    routes: defaultRoutes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }
    },
  });

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

const router = createRouter();

export const getRoutes = (role) => {
  return routes.filter((item) => {
    if (!item.meta.roles) return true;
    for (let i = 0; i < role.length; i++) {
      if (item.meta.roles.includes(role[i])) {
        return true;
      }
    }
    return false;
  });
};

router.beforeEach(async (to, from, next) => {
  if (store.state.user.token) {
    const roles = await store.dispatch("user/getRole");
    if (!roles) {
      await store.dispatch("user/logout", { diableGetAuth: true });
      next("/");
    } else if (store.state.user.routes) {
      if (to.query.redirectUrl) {
        next(to.query.redirectUrl);
      } else if (
        (to.path === "/" || to.name === "Login") &&
        (roles.includes(roleEnum.RECRUIT.name) ||
          roles.includes(roleEnum.RECRUIT_MANAGER.name))
      ) {
        let userInfo = await store.dispatch("user/getUserInfo");
        next({
          name: "Enterprise",
          params: {
            id: userInfo.enterpriseId,
          },
        });
      } else if (
        (to.path === "/" || to.name === "Login") &&
        roles.includes(roleEnum.ADMIN.name)
      ) {
        next({
          path: "/platform/cover",
        });
      } else if (
        (to.path === "/" || to.name === "Login") &&
        roles.includes(roleEnum.CANDIDATE.name)
      ) {
        next({
          name: "CollegeRecruit",
        });
      } else {
        if (hasRoute(to)) {
          if (to.name === "SocialRecruit") {
            next();
          } else if (
            to.name === "CollegeRecruit" &&
            to.query.positionType == 3
          ) {
            next({
              ...to,
              name: "SocialRecruit",
            });
          } else {
            next();
          }
        } else {
          next("/");
        }
      }
    } else {
      let routes = getRoutes(roles);
      routes.forEach((item) => {
        !hasRoute(item) && router.addRoute(item);
      });
      store.commit("user/SET_ROUTES", routes);
      next({ ...to, replace: true });
    }
  } else {
    store.commit("user/SET_ROUTES", defaultRoutes);
    if (hasRoute(to)) {
      if (hasRoute(to)) {
        if (to.name === "SocialRecruit") {
          next();
        } else if (to.name === "CollegeRecruit" && to.query.positionType == 3) {
          next({
            ...to,
            name: "SocialRecruit",
          });
        } else {
          next();
        }
      } else {
        next("/");
      }
    } else {
      let token;
      try {
        token = await store.dispatch("user/getToken");
      } catch (err) {
        console.log(err);
      }
      if (token) {
        store.commit("user/SET_ROUTES", null);
        next("/");
      } else {
        console.log(to);
        utils.hasRole(to, roleEnum.CANDIDATE.name)
          ? next({
              name: "CollegeRecruit",
            })
          : next({
              name: "Login",
              query: {
                redirectUrl: to.fullPath === "/" ? undefined : to.fullPath,
              },
            });
      }
    }
  }
});

router.afterEach((to, from) => {
  document.title = `上汽${to.meta.isCandidatePage ? "" : "集团"}招聘`;
  if (to.name === "Login") {
    document.body.classList.remove("body-scale");
  } else {
    document.body.classList.add("body-scale");
    if (device.isIE()) {
      document.body.classList.add("ie");
    }
  }
  store.commit("form/SET_SHOW_LOGIN", false);
});

/**
 * 判断当前路由是否存在
 * @param to
 * @returns {boolean}
 */
function hasRoute(to) {
  let find = router.getRoutes().find((item) => item.name === to.name);
  return !!find;
}

const a = async (store) => {
  let status = await store.dispatch("user/getPasswordStatus");
};

export default router;
